export var DistanceType;
(function (DistanceType) {
  DistanceType["EuclideanDistance"] = "euclideanDistance";
})(DistanceType || (DistanceType = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/algorithm/es/types.js
// module id = null
// module chunks = 